export default "__VITE_ASSET__B073piir__"